import { Divider, Grid } from '@mui/material';
import { RoundedSkeleton } from '../Common/Skeleton';

function LoadingRecordings() {
  return (
    <Grid display="flex" gap={2} flexDirection="column" mt={2}>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <RoundedSkeleton height={14.875} width={203} />
        <img src="/assets/icons/loading-menu-dots.svg" alt="loading-menu-dots" />
      </Grid>
      <Divider />
    </Grid>
  );
}

export default LoadingRecordings;
